import React, { useEffect, useRef, useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux'
import LandLordTopBar from "../components/Header/LandLordTopBar";
import LandLordSideBar from "../components/Header/LandLordSideBar";

const pageTitles = {
  "/landlords": "Overview",
  "/landlords/insights": "Business Health Dashboard",
  "/landlords/managelands": "Property Details: Units & Tenants",
  "/landlords/payments/:unitId": "View Payments",
  "/landlords/portfolio-performance-report" : "Portfolio Performance Report",
  "/landlords/occupancy-rate" : "Occupancy Insights",
  "/landlords/payment-distribution" : "Payment Distribution Report",
  "/landlords/payment-history" : "Payment History",
  "/landlords/paymentmonitoring": "Notification Center",
  "/landlords/legalSupport": "Legal Support",
  "/landlords/reqMaintaince": "Request Maintenance",
  "/landlords/taxConsulation": "Tax Consultation Request",
  "/landlords/paymonitoring": "Payment Monitoring",
  "/landlords/support-email-settings": "Support Email Settings",
  "/landlords/support-logs": "Support Logs",
  "/landlords/tenant-payment-activity" : "Tenant Payment Activity",
  "/landlords/admin-manage-landload": "Manage Landlods",
  "/landlords/admin-manage-landload/profile": "Landlord Profile",
  "/landlords/admin-manage-landload/view-properties": "Manage Properties",
  "/landlords/admin-manage-landload/manage-property/view-details": "Property Details: Units & Tenants",
  "/landlords/manage-property/tenant-details-form/:unitId": "Tenant Details",
  "/landlords/manage-property/add-tenant": "Tenant Details",
  "/landlords/manage-property/payments": "View Payments",
  "/landlords/admin-payout": "Payouts",
  "/landlords/admin-payment-history": "Payment History",

};

const LandlodLayout = () => {
  const location = useLocation();
  const contentRef = useRef(null);
  const { user } = useSelector((state) => state.auth);

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);
  const temp = Object.keys(pageTitles)?.filter((it) => {
    if (
      it?.split("/")?.slice(1, 4)?.join("/") ===
      location.pathname?.split("/")?.slice(1, 4)?.join("/")
    ) {
      return it;
    }
  });
 // const title = pageTitles[temp[0]] || "Overview Page Content";

  // Create user object with firstname and lastname
  const userProfile = {
    name: user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : 'Guest User',
    profilePicture: user?.profilePicture || null,
    email: user?.email || null,
    ...user
  };

    const matchKey = Object.keys(pageTitles).find((key) =>
      key.split("/").slice(1, 4).join("/") === location.pathname.split("/").slice(1, 4).join("/")
    );
  
    // Special case: dynamic title for /view-properties/:id
    const isManagePropsRoute = location.pathname.startsWith(
      "/landlords/admin-manage-landload/view-properties"
    );
  
    const stateName = location.state?.landlordName;
    const storedName = typeof window !== "undefined"
      ? sessionStorage.getItem("currentLandlordName")
      : "";
  
    const landlordName = stateName || storedName || "";
  
      // Logic to match dynamic routes and handle `add-tenant` and `edit-tenant` specifically
      let title = "Overview Page Content";

      // Special tenant routes
      if (
        location.pathname.includes("manage-property") &&
        (location.pathname.includes("add-tenant") || location.pathname.includes("edit-tenant"))
      ) {
        title = "Tenant Details";
      
      } else if (isManagePropsRoute) {
        // Special manage properties case with optional landlord name
        title = `Manage Properties${landlordName ? ` - ${landlordName}` : ""}`;
      
      } else {
        // Match against pageTitles keys
        const matchKey = Object.keys(pageTitles).find(
          (key) =>
            key.split("/").slice(1, 4).join("/") ===
            location.pathname.split("/").slice(1, 4).join("/")
        );
        title = pageTitles[matchKey] || "Overview Page Content";
      }      

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen min-w-[320px] w-full bg-white">
      <aside className="fixed top-0 left-0 z-40 h-full">
        <LandLordSideBar />
      </aside>
      <div className="lg:ml-[300px] h-screen flex flex-col">
        <div className="h-[79px]">
          <LandLordTopBar title={title} user={userProfile}/>
        </div>
        <div ref={contentRef}className="w-full flex-1 bg-[#F5F7FA] overflow-y-auto overflow-x-hidden pb-10">
          <Outlet key={location.pathname} />
        </div>
      </div>
    </div>
  );
};

export default LandlodLayout;
